import { useEffect, useRef } from 'react'

/**
 * Darstellung › „Seitenleiste ausblenden" (Electron-Menü).
 *
 * Ein Klick auf den Menüeintrag schaltet um wie der Titlebar-Knopf, und der
 * Zustand geht zurück an den Main-Prozess, damit der Eintrag „ausblenden" oder
 * „einblenden" heißt. ⌘B selbst läuft nicht hierüber — das fängt weiter der
 * `keydown`-Handler in MainLayout (das Menü registriert das Kürzel nicht).
 */
export function useSidebarMenuBridge(toggleSidebar: () => void, sidebarOpen: boolean): void {
  const toggleRef = useRef(toggleSidebar)
  toggleRef.current = toggleSidebar

  useEffect(() => {
    if (!window.api?.receive) return
    const unsubscribe = window.api.receive('toggle-sidebar', () => toggleRef.current())
    return () => { unsubscribe?.() }
  }, [])

  useEffect(() => {
    window.api?.send?.('sidebar:state', sidebarOpen)
  }, [sidebarOpen])
}
